export default __webpack_public_path__ + "static/media/mail.7ca1450f.svg";